import React from 'react';
import Backgroundimage from '../../assets/images/background/image-4.jpg';
import { Link } from 'react-router-dom'
import logonew from '../../assets/images/logo.png'


function Main() {
    return (
        <>

            <footer className="main-footer">
                <div className="image-layer" style={{ backgroundImage: `url(${Backgroundimage})` }}> </div>
                <div className="upper-section">
                    <div className="auto-container">
                        <div className="row clearfix">

                            <div className="footer-col info-col col-lg-6 col-md-12 col-sm-12">
                                <div className="inner wow fadeInUp" data-wow-delay="0ms" data-wow-duration="1500ms">
                                    <div className="content">
                                        <div className="logo"><Link to="/" title="Родос - Гръцки Ресторант"><img src={logonew} alt="" title="Родос - Гръцки Ресторант" /></Link></div>
                                        <div className="info">
                                            <ul>
                                                <li>ул.Емборе 8 кв.Орландовци, София</li>
                                                <li><Link to="mailto:atanasmartin1988@gmail.com">atanasmartin1988@gmail.com
</Link></li>
                                                <li><Link to="tel:+359 88 555 6520">Резервация: 088 555 6520</Link></li>
                                                <li>Отворено - всеки ден : 10:30 - 22:30</li>
                                            </ul>
                                        </div>
                                        <div className="separator"><span></span><span></span><span></span></div>
                               
                                    </div>
                                </div>
                            </div>

                            <div className="footer-col links-col col-lg-3 col-md-6 col-sm-12">
                                <div className="inner wow fadeInLeft" data-wow-delay="0ms" data-wow-duration="1500ms">
                                    <ul className="links">
                                        <li> <Link to="/">Начало</Link></li>
                                        <li> <Link to="/menu">Меню</Link></li>
                                     
                                    </ul>
                                </div>
                            </div>

                            <div className="footer-col links-col last col-lg-3 col-md-6 col-sm-12">
                                <div className="inner wow fadeInRight" data-wow-delay="0ms" data-wow-duration="1500ms">
                                    <ul className="links">
                                        <li> <a href="https://www.facebook.com/profile.php?id=100094072915174">facebook</a></li>
                                         {/* <li> <a href="https://www.instagram.com">instagram</a></li> */}
                                        {/* <li> <a href="https://twitter.com">Twitter</a></li> */}
                                        {/* <li> <a href="https://www.youtube.com">Youtube</a></li> */}
                                        <li> <a href="https://www.google.com/maps/place/%D0%93%D1%80%D1%8A%D1%86%D0%BA%D0%B8+%D1%80%D0%B5%D1%81%D1%82%D0%BE%D1%80%D0%B0%D0%BD%D1%82+%D0%B8+%D0%BF%D0%B8%D1%86%D0%B0+%22%D0%A0%D0%BE%D0%B4%D0%BE%D1%81%22/@42.7211243,23.3311159,15z/data=!4m2!3m1!1s0x0:0xd12f7f6c6ff28be8?sa=X&ved=2ahUKEwjAhOz7ypeAAxVLRvEDHWmMCGYQ_BJ6BAgvEAA&hl=bg-BG&ved=2ahUKEwjAhOz7ypeAAxVLRvEDHWmMCGYQ_BJ6BAg9EAg">Google map</a></li> 
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* <div className="footer-bottom">
                    <div className="auto-container">
                        <div className="copyright">&copy; 2022 Restaurt. All Rights Reserved   |    Crafted by <Link to="https://themeforest.net/user/kalanidhithemes" target="blank">Kalanidhi Themes</Link></div>
                    </div>
                </div> */}

            </footer>
            <div className="scroll-to-top scroll-to-target" data-target="html"><span className="icon fa fa-angle-up"></span></div>

        </>

    )
}

export default Main